import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F5F6]">
        <div className="font-display text-3xl text-[#2C3539] tracking-wider" data-testid="auth-loading">
          LOADING<span className="text-[#2F5F80]">.</span><span className="text-[#2F5F80]">.</span><span className="text-[#2F5F80]">.</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={redirectState} />;
  return children;
}
